import styled from '@emotion/styled'

import Image from '@segment/matcha/components/Image'

import deliverExperiences from './assets/DeliverExperiences.png'
import deliverExperiencesWebp from './assets/DeliverExperiences.webp'

const DeliverExperiencesImage = () => {
  return (
    <Picture>
      <source type="image/webp" srcSet={`${deliverExperiencesWebp}`} />
      <Image
        src={deliverExperiences}
        alt="Illustration: Deliver relevant experiences to each customer"
        width="600"
        height="709"
        loading="lazy"
      />
    </Picture>
  )
}

const Picture = styled.picture``

export default DeliverExperiencesImage
